import { MembershipTier } from '../data-models/membership-tier.model';

export type MembershipTierGuardDecision =
  | { allow: true }
  | { allow: false; redirectTo: string };

/**
 * Pure decision logic for `MembershipTierGuard`, extracted so it's testable
 * without importing `@angular/router` — this repo's Jest config has no
 * `transformIgnorePatterns` for Angular's ESM-only packages, so even a bare
 * import of `@angular/router` (not just TestBed usage) fails to parse here,
 * confirmed directly (see membership-tier.guard.spec.ts's git history / PR
 * discussion). The guard class is a thin wrapper calling this with values
 * already read from RxJS/Angular Router.
 */
export function resolveMembershipTierAccess(params: {
  isAuthenticated: boolean;
  requiredTier: MembershipTier | undefined;
  isPro: boolean;
  preview?: string;
}): MembershipTierGuardDecision {
  const { isAuthenticated, requiredTier, isPro, preview } = params;

  if (!isAuthenticated) return { allow: false, redirectTo: '/login' };

  if (!requiredTier) {
    // Reaching this function at all means MembershipTierGuard was attached
    // to the route — Angular only invokes a guard listed in that route's
    // own canActivate. A missing data.requiredTier is therefore always a
    // misconfiguration (someone added the guard but forgot the data), never
    // "this route wasn't meant to be gated." Fail closed rather than
    // silently letting a misconfigured route through.
    return { allow: false, redirectTo: preview || '/dashboard' };
  }

  if (requiredTier === 'pro' && !isPro) {
    return { allow: false, redirectTo: preview || '/dashboard' };
  }
  return { allow: true };
}
